var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-menu",
        {
          staticClass: "el-menu-demo",
          attrs: { "default-active": _vm.activeIndex, mode: "horizontal" },
          on: {
            select: function($event) {
              return _vm.handover($event)
            }
          }
        },
        [
          _c("el-menu-item", { attrs: { index: "automaticServerNew" } }, [
            _vm._v(_vm._s(_vm.$t("autoServerConfig")))
          ]),
          _c("el-menu-item", { attrs: { index: "handleServer" } }, [
            _vm._v(_vm._s(_vm.$t("manualServerConfig")))
          ])
        ],
        1
      ),
      _c("automaticServerNew", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "automaticServerNew",
            expression: "activeIndex == 'automaticServerNew'"
          }
        ],
        ref: "automaticServerNew"
      }),
      _c("handleServer", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "handleServer",
            expression: "activeIndex == 'handleServer'"
          }
        ],
        ref: "handleServer"
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }